// extracted by mini-css-extract-plugin
module.exports = {"welcome":"Home_welcome__Qxzze","promoText":"Home_promoText__s3zDn"};